import instance from "../utils/request.js"
import { getRequest } from "../utils/request.js"

/*获取人员信息*/
export function GetPersonnel(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/personnel/",
        params:data
    })
}

/*获取人员编辑信息*/
export function PersonnelEditInfo(data = {}){
return instance.request({
        method: "get",
        url: "lzjaiopsbase/personneledit/",
        params:data
    })
}

/*人员编辑*/
export function PersonnelEdit(data = {}){
    let params = new URLSearchParams();
    params.append('personnelid',data.personnelid);
    params.append('fullname',data.fullname);
    params.append('gender',data.gender);
    params.append('state',data.state);
    params.append('telephone',data.telephone);
    params.append('creationtime',data.creationtime);
    params.append('modificationtime',data.modificationtime);
return instance.request({
        method: "post",
        url: "lzjaiopsbase/personneledit/",
        data:params
    })
}

/*人员新增*/
export function PersonnelAdd(data = {}){
    let params = new URLSearchParams();
    params.append('fullname',data.fullname);
    params.append('gender',data.gender);
    params.append('state',data.state);
    params.append('telephone',data.telephone);
    params.append('creationtime',data.creationtime);
    params.append('modificationtime',data.modificationtime);
return instance.request({
        method: "post",
        url: "lzjaiopsbase/personneladd/",
        data:params
    })
}

/*人员删除*/
export function PersonnelDel(data = {}){
    let params = new URLSearchParams();
    params.append('personnelid',data.personnelid)
return instance.request({
        method: "post",
        url: "lzjaiopsbase/personneldel/",
        data:params
    })
}